import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { orderToken, getConversion } from "../../../actions";
import { withStyles } from "@material-ui/styles";
import Stepper from "@material-ui/core/Stepper";
import { Step, StepLabel, StepContent } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
// import { withGTM } from "react-tag-manager";
//import process3kycImage from "../../../img/process-3-kyc.png";
import InvestmentForm from "../InvestmentForm/index";
import PaymentInfo from "../../molecules/Paymentinfo";

const styles = theme => ({
  root: {
    width: "99%"
  },
  backButton: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  process3kycImage: {
    textAlign: "center"
  }
});

const mapStateToProps = state => {
  return {
    activeStep: state.order.step,
    order: state.order,
    user: state.User
  };
};

const mapDispatchToProps = dispatch => {
  return {
    orderToken: order => dispatch(orderToken(order)),
    getConversion: () => dispatch(getConversion())
  };
};

function getSteps() {
  return ["Payment method", "Transaction details"];
}

class OrderProcessSimple extends React.Component {
  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
  }
  componentDidMount() {
    this.props.getConversion();
  }
  //   componentDidMount() {
  //     const { GTM } = this.props;
  //     const path = [
  //       "/i/dashboard/registration",
  //       "/i/dashboard/emailverification",
  //       "/i/dashboard/identityverification",
  //       "/i/dashboard/walletwhitelisting",
  //       "/i/dashboard/paymentinformation"
  //     ];

  //     GTM.api.trigger({
  //       event: "pageViewProcess",
  //       path: path[this.props.step]
  //     });
  //   }

  handleNext = () => {
    // const { activeStep } = this.state;
    // this.setState({
    //   activeStep: activeStep + 1
    // });
  };

  //   handleBack = () => {
  //     const { activeStep } = this.state;
  //     this.setState({
  //       activeStep: activeStep - 1
  //     });
  //   };

  //   handleReset = () => {
  //     this.setState({
  //       activeStep: 0
  //     });
  //   };
  handleSave(data) {
    this.props.orderToken(data.data);
  }
  getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <React.Fragment>
            <Typography variant="h5" gutterBottom>
              Select payment method and calculate price
            </Typography>
            <InvestmentForm
              save={this.handleSave}
              next={this.handleNext}
              data={this.props.order}
              reload={this.props.getConversion}
            />
          </React.Fragment>
        );
      case 1:
        return (
          <PaymentInfo
            order={this.props.order.investment}
            user={this.props.user}
          />
        );

      default:
        return <Typography>'Unknown stepIndex'</Typography>;
    }
  }

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const { activeStep } = this.props;
    //console.log("order", this.props.order);
    return (
      <div className={classes.root}>
        <Typography variant="h3" align="center">
          Token Order
        </Typography>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((label, index) => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  {index <= activeStep && this.getStepContent(index)}
                </StepContent>
              </Step>
            );
          })}
        </Stepper>
      </div>
    );
  }
}

OrderProcessSimple.propTypes = {
  classes: PropTypes.object
};

const OrderProcessSimpleStepper = connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderProcessSimple);
// const gtmOrderProcessSimple = withGTM(OrderProcessSimpleStepper);
const gtmOrderProcessSimple = OrderProcessSimpleStepper;

export default withStyles(styles)(gtmOrderProcessSimple);
